import React from 'react';
import { Link } from "react-router-dom";
import { useInstallPrompt } from '../../../installPrompt.js';

// Links shared by the NavBar and the Footer
export default function SiteLinks({ className = "", id, onNavigate, phoneMenu = false }) {
    const [canInstall, install] = useInstallPrompt();

    return (
        <div className={`SiteLinks ${className}`.trim()} id={id} onClick={onNavigate}>
            <a href="https://kizabo.com/#section-292-9" className="SiteLinks--link">BENEFITS</a>
            <a href="https://kizabo.com/#section-1184-7" className="SiteLinks--link">MEET THE TEAM</a>
            {/* Phone menu only: the footer (and its contact link) is hidden on the app-like assessment screen */}
            {phoneMenu && <a href="mailto:support@kizabo.com" className="SiteLinks--link SiteLinks--phone-only">CONTACT US</a>}
            {phoneMenu && canInstall && <button type="button" className="SiteLinks--link SiteLinks--phone-only SiteLinks--install" onClick={install}>INSTALL APP</button>}
            <Link to="/login" className="SiteLinks--app">LOGIN</Link>
        </div>
    );
}
